import React from 'react'
import PlayKaroCasinoCatalog from './PlayKaroCasinoCatalog'
import type { PkCasinoCatalogConfig } from './playKaroCasinoCatalogTypes'
import {
  PK_SLOT_BANNERS,
  PK_SLOT_CATEGORIES,
  PK_SLOT_LIST_PROVIDERS,
  PK_SLOT_SEARCH_TERMS,
  PK_SLOT_SEED_PROVIDERS,
  resolveSlotProviderIcon,
} from './playKaroSlotsData'

function includeEveryGame(_game: Record<string, unknown>): boolean {
  return true
}

const SLOTS_CATALOG: PkCasinoCatalogConfig = {
  catalogId: 'slots',
  banners: PK_SLOT_BANNERS,
  categories: PK_SLOT_CATEGORIES,
  seedProviders: PK_SLOT_SEED_PROVIDERS,
  showAllFoundProviders: true,
  searchTerms: PK_SLOT_SEARCH_TERMS,
  listProviders: PK_SLOT_LIST_PROVIDERS,
  listTypes: ['slots', 'live-casino'],
  filterGame: includeEveryGame,
  resolveProviderIcon: resolveSlotProviderIcon,
  loadingLabel: 'Loading slots…',
  emptyLabel: 'No games found.',
}

type PlayKaroSlotsProps = {
  preLoginMode?: boolean
  onLoginRequired?: () => void
}

const PlayKaroSlots: React.FC<PlayKaroSlotsProps> = ({ preLoginMode, onLoginRequired }) => (
  <PlayKaroCasinoCatalog config={SLOTS_CATALOG} preLoginMode={preLoginMode} onLoginRequired={onLoginRequired} />
)

export default PlayKaroSlots

export { SLOTS_CATALOG }
